import './HelpModal.scss';

import { useFeedbackForm } from "../hooks/useFeebackForm";

import { Field } from "../common-components/Field/Field";
import { Button } from "../common-components/Buttons/Buttons";

const HelpModal = () => {
    const {formId, handleSend} = useFeedbackForm();

    return (
        <div className={"help-modal"}>
            <div className={"help-modal_container"}>
                <div className={"help-modal_title"}>
                    {"Обратная связь"}
                </div>
                <form className={"help-modal_form"}>
                    <Field
                        label={"Причина обращения"}
                        name={"title"}
                        formId={formId}
                        type={"text"}
                        validationRules={{required: true}}
                    />
                    <Field
                        label={"Описание проблемы"}
                        name={"feedback"}
                        formId={formId}
                        type={"textarea"}
                        validationRules={{required: true}}
                    />
                </form>
                <div className={"help-modal_button"}>
                    <Button title={"Отправить"} onClick={handleSend}/>
                </div>
            </div>
        </div>
    )
}

export default HelpModal;